import type { Situation } from '@policyvision/contracts';
import { forwardRef } from 'react';

import { ValidationResult } from '@/policy/types/ValidationResult';

import { ValidableSection } from '../Validation/ValidableSection';
import { PolicyCoverageTable } from './PolicyCoverageTable';

interface PolicyCoverageSectionProps {
  situation: Situation;
  showTitle?: boolean;
  validation: ValidationResult;
  onValidationChange: (validation: ValidationResult) => void;
  isSelected: boolean;
  onTableClick: (sectionUuid: string) => void;
}

export const PolicyCoverageSection = forwardRef<
  HTMLDivElement,
  PolicyCoverageSectionProps
>(
  (
    {
      situation,
      showTitle = true,
      validation,
      onValidationChange,
      isSelected,
      onTableClick,
    },
    ref,
  ) => {
    return (
      <ValidableSection
        ref={ref}
        title={showTitle ? situation.title : undefined}
        sectionIdentifier={situation.uuid}
        validation={validation}
        onValidationChange={onValidationChange}
        isSelected={isSelected}
        onTableClick={onTableClick}
      >
        <PolicyCoverageTable sections={situation.warranties} />
      </ValidableSection>
    );
  },
);

PolicyCoverageSection.displayName = 'PolicyCoverageSection';
